import React, { useEffect, useState } from 'react';
import { Controller } from 'react-hook-form';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { DynamicForm, CustomerConfig, DeleteConfig } from '../../../../components';
import {inputDate} from '../../../../utils/utils';


const CustomerProfile = ({
  photo,
  handleImgChange,
  customerData, // Data passed from parent (NewEmployee)
  onSubmit, //handleEmployeeProfileSubmit from NewEmployee
  isLoading,
  countries,
  regions,  
  cities,   
  onCancel, //onCancel prop from parent
  control, // control object from the parent 
  errors, // <-- `errors` comes from the parent
  reset, //  `reset` as a prop
  isReadOnly, // for view page.
  deleting  // for delete page 
}) => {
console.log('customer data  sir in Customer Profile .',customerData)

let updatedCustomerConfig;
  if (deleting) {
    updatedCustomerConfig = DeleteConfig;
  } else {
    updatedCustomerConfig = CustomerConfig?.map(field => {
      let updatedField = { ...field };

      if (updatedField.name === 'country_id') {
        updatedField = {
          ...updatedField,
          options: [
            { id: '', name: 'Select Country', disabled: true, hidden: true },
            ...(Array.isArray(countries) ? countries : []),
          ]
        };
      } else if (updatedField.name === 'region_id') {
        updatedField = {
          ...updatedField,
          options: [
            { id: '', name: 'Select Region', disabled: true, hidden: true },
            ...(Array.isArray(regions) ? regions : []),
          ],
        };
      } else if (updatedField.name === 'district_id') { // NEW: Handle the cities field
        updatedField = {
          ...updatedField,
          options: [
            { id: '', name: 'Select City', disabled: true, hidden: true },
            ...(Array.isArray(cities) ? cities : []),
          ],
        };
      }
      return updatedField;
    });
  }

// Use useEffect to reset the form with `customerData` when it changes
useEffect(() => {
  if (customerData && reset) {
    // Create a flattened data object for react-hook-form
    reset({
      ...customerData,
      name: customerData.name,
      // Ensure country, region, city are correctly mapped if they are part of customerData
      country_id: customerData?.country_id,
      region_id: customerData?.region_id,
      district_id: customerData?.district_id,
      created_time:inputDate(customerData?.created_time),
  
    });
  }
}, [customerData, reset]);
 
// --- IMPORTANT: ADD THIS useEffect to log validation errors ---
  useEffect(() => {
    if (Object.keys(errors).length > 0) {
      console.error("CustomerProfile: Validation Errors detected:", errors);
      toast.error('Please fill in all required fields.');
    }
  }, [errors]);

  // --- IMPORTANT: This function is called by react-hook-form's handleSubmit ---
  const handleFormSubmit = (dataFromForm) => {
    onSubmit(dataFromForm);    // This is where your actual onSubmit (handleEmployeeProfileSubmit) is called
  };

  //This will call NewEmployee's handleCancel
  const handleProfileCancel = () => {if (onCancel) {onCancel(); }};

  return (
    <form onSubmit={onSubmit} className="space-y-8">
     
      {/* The rest of the fields rendered by DynamicForm */}
      <div className="md:col-span-2">
        <DynamicForm
          fields={updatedCustomerConfig}
          key={regions?.length || 0}
          // uoms={uoms}
          data={customerData}
          onSubmit={handleFormSubmit}
          isLoading={isLoading}
          control={control} // Pass shared control to DynamicForm
          onCancel={handleProfileCancel} // Pass the cancel handler to DynamicForm
          errors={errors} // <-- Pass the errors object 
          isReadOnly={isReadOnly}
          // Explicitly pass these lists to DynamicForm
          countries={countries}
          regions={regions}
          cities={cities}

            
        />
      </div>
    </form>
  );
}
export default CustomerProfile;
